import React from 'react';
import { Button, IconButton, makeStyles } from '@material-ui/core';
import { Link } from '@reach/router';
import { ReactComponent as BackIcon } from '../../images/svg/arrow.svg';
import { useTranslation } from 'react-i18next';

// styles
const useStyles = makeStyles((theme) => {
  const s = (x: number) => theme.spacing(x);
  return {
    icon: {
      width: 100,
      height: 25,
      transform: 'scaleX(-1)',
      '& path': {
        fill: `${theme.palette.secondary.main} !important`,
      },
    },
    btn: {
      paddingLeft: 0,
      paddingRight: 0,
      minWidth: 'auto',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    topSpacing: {
      marginTop: s(1),
      [theme.breakpoints.up('sm')]: { marginTop: s(2) },
      [theme.breakpoints.up('md')]: { marginTop: s(3) },
      [theme.breakpoints.up('lg')]: { marginTop: s(4) },
    },
  };
});

// props
interface AppBackLinkProps {
  to?: string;
  isGoBackActivated?: boolean;
  onClick?: () => void;
  /** Adds responsive top margin for pages where this is the first element below the fixed navbar. */
  topSpacing?: boolean;
}

/**
 * Generic "Back" icon button-link component.
 */
export default function AppBackLink({ to = '/', isGoBackActivated = false, onClick, topSpacing = false }: AppBackLinkProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const rootClass = `${classes.btn}${topSpacing ? ` ${classes.topSpacing}` : ''}`;

  if (isGoBackActivated) {
    return (
      <Button
        disableRipple
        classes={{
          root: rootClass,
        }}
        onClick={() => {
          onClick && onClick();
          window.history.back();
        }}
        aria-label={t('Go back')}
      >
        <BackIcon className={classes.icon} />
      </Button>
    );
  }

  return (
    <IconButton
      component={Link}
      disableRipple
      to={to}
      classes={{
        root: rootClass,
      }}
      aria-label={t('Go back')}
    >
      <BackIcon className={classes.icon} />
    </IconButton>
  );
}
